import type { ReactElement } from 'react';
import { Button, Heading, Image, Page, Paragraph } from '@zillow/constellation-10';
import Error from '../../../../images/error.svg';

export function ErrorPage({ errorDetails, errorMessage, homePageText, homePageUrl }: ErrorPageProps): ReactElement {
  return (
    <Page.Root css={{ backgroundColor: 'white' }}>
      <Page.Content>
        <Image src={Error} alt="picture of a dog holding an electric plug in its mouth" css={{ marginTop: 'looser' }} />
        <Heading level={1} css={{ textStyle: 'responsive.heading-md' }}>
          {errorMessage}
        </Heading>
        {errorDetails ? <Paragraph css={{ marginTop: 'tight' }}>{errorDetails}</Paragraph> : null}
        {homePageText && homePageUrl && (
          <Button css={{ marginTop: 'loose' }} tone="brand" emphasis="filled" asChild>
            <a href={homePageUrl}>{homePageText}</a>
          </Button>
        )}
      </Page.Content>
    </Page.Root>
  );
}

interface ErrorPageProps {
  errorMessage?: string;
  errorDetails?: React.ReactNode;
  homePageText?: string;
  homePageUrl?: string;
}
